// Supported theme options and the rules for validating a stored preference.
//
// The color values behind each accent live in src/styles/theme.css; this file
// only lists what the user can pick. To add an accent: add an entry here, add
// its `[data-accent="<id>"]` block in theme.css, and add the id to the
// pre-paint script in public/index.html.

export const APPEARANCES = [
  { id: "light", label: "Light" },
  { id: "dark", label: "Dark" },
  { id: "system", label: "System" },
];

// `swatch` is only used to paint the picker button; it matches each accent's
// --color-primary in light mode.
export const ACCENT_COLORS = [
  { id: "blue", label: "Blue", swatch: "#2563eb" },
  { id: "violet", label: "Violet", swatch: "#7c3aed" },
  { id: "emerald", label: "Emerald", swatch: "#047857" },
  { id: "teal", label: "Teal", swatch: "#0f766e" },
  { id: "rose", label: "Rose", swatch: "#e11d48" },
  { id: "amber", label: "Amber", swatch: "#b45309" },
  { id: "orange", label: "Orange", swatch: "#c2410c" },
  { id: "slate", label: "Slate", swatch: "#475569" },
];

export const DEFAULT_THEME_PREFERENCES = Object.freeze({
  appearance: "light",
  accentColor: "blue",
});

const APPEARANCE_IDS = new Set(APPEARANCES.map((a) => a.id));
const ACCENT_IDS = new Set(ACCENT_COLORS.map((a) => a.id));

export const isAppearance = (value) => APPEARANCE_IDS.has(value);
export const isAccentColor = (value) => ACCENT_IDS.has(value);

// Keeps each valid field and falls back to the default for anything else, so
// one bad value doesn't discard the other.
export function normalizeThemePreferences(value) {
  const source = value && typeof value === "object" ? value : {};
  return {
    appearance:
      isAppearance(source.appearance) ?
        source.appearance
      : DEFAULT_THEME_PREFERENCES.appearance,
    accentColor:
      isAccentColor(source.accentColor) ?
        source.accentColor
      : DEFAULT_THEME_PREFERENCES.accentColor,
  };
}
